/**
 * @file index.tsx
 *
 * @fileoverview A component that hides its contents on desktop.
 */
import React from "react";
import styles from "../visibility.module.scss";

interface HideDesktopProps {
  /**
   * The contents to hide on desktop.
   */
  children: React.ReactNode;
  /**
   * An optional class name to apply to the component.
   */
  className?: string;
}

/**
 * The component will hide its contents when viewed on a tablet and large devices.
 * The width for the breakpoint is defined in the theme object.
 */
export function HideDesktop({ children, className = "" }: HideDesktopProps) {
  return <div className={`${styles.hideDesktop} ${className}`}>{children}</div>;
}

export default HideDesktop;
